var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[(_vm.empty)?_c('div',{staticClass:"none"}):_vm._e(),_c('div',{staticClass:"wrap",on:{"click":_vm.click}},[(_vm.loading)?_c('div',{staticClass:"image"}):_vm._e(),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }